import { useNavigate } from 'react-router-dom'

/**
 * Hook for resetting navigation (equivalent of React Navigation reset)
 * Adapted version for web
 */
export function useResetNavigation() {
  const navigate = useNavigate()

  const resetTo = (path: string) => {
    // Remove leading slashes for normalization
    const normalizedPath = path.replace(/^\/+/, '')

    // In web, use replace to replace the current history entry
    // This is equivalent to reset in React Navigation
    navigate(`/${normalizedPath}`, { replace: true })
  }

  return resetTo
}
